import { useEffect } from 'react';
import Header from '../components/Header';
import Carousel from '../components/Carousel';
import Grid from '../components/Grid';
import Footer from '../components/Footer';

export default function Home() {
  useEffect(() => {
    document.title = 'Four A Tacos — Restaurant à Chambéry';
  }, []);

  return (
    <div style={{ paddingTop: '80px', backgroundColor: '#f5f5f5', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Header />
      <Carousel />
      <div style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '48px 0' }}>
        <div className="max-container" style={{ width: '100%' }}>
          <Grid />
        </div>
      </div>
      <Footer />
    </div>
  );
}
